/** @jsx jsx */
import { jsx } from "theme-ui"
import { Themed } from '@theme-ui/mdx'
import { connect } from "react-redux"
import Container from "@components/Container"
import Section from "@components/Section"
import CalloutTextBlocks from "@components/CalloutTextBlocks"
import TwoColumnSection, {
  Block as ColumnBlock,
} from "@components/TwoColumnSection"
import CTAHeadingBlock from "@components/CTAHeadingBlock"
import footerImage from "@static/images/impact-footer.jpg"
import DonateCard from "@components/DonateCard"
import { Grid } from "@theme-ui/components"
import { rem } from "@src/theme"
import { navigate } from "@reach/router"
import { BodyLarge } from "@components/primitives/Text"
import Spacer from "@components/Spacers"
import Button from "@components/Button"

const donateCardsData = [
  {
    amount: "20",
    text:
      "Is enough to provide a young person with resources on sexuality and gender identity.",
  },
  {
    amount: "50",
    text: "Sends an LGBTQIA+ teen to the life-affirming Queer Formal for free.",
  },
  {
    amount: "188",
    text: "Provides LGBTQIA+ education resources to one Aussie classroom.",
  },
]

const DonateSectionBase = ({ openDonationModal }) => (
  <div
    sx={{
      bg: "yellow",
    }}
  >
    <Spacer.Medium />
    <Container
      sx={{
        maxWidth: rem(1209),
      }}
    >
      <Themed.h2
        sx={{
          textAlign: "center",

          mt: 0,
        }}
      >
        Your donations keep us going
      </Themed.h2>

      <BodyLarge
        style={{
          mb: rem(80),
          textAlign: "center",
        }}
      >
        Minus18 Foundation Ltd is a registered Australian charity. All donations
        are tax-deductible.
      </BodyLarge>

      <Grid columns={[1, null, 2, 3]} gap={2}>
        {donateCardsData.map(({ amount, text }) => (
          <DonateCard amount={amount} text={text} key={amount} />
        ))}
      </Grid>
    </Container>
    <Spacer.Medium />
    <div sx={{ display: "flex", justifyContent: "center" }}>
      <Button bg="darkPurple" color="white" onClick={openDonationModal}>
        Donate
      </Button>
    </div>
    <Spacer.Medium />
  </div>
)

export const DonateSection = connect(null, dispatch => ({
  openDonationModal: () => dispatch.donationModal.toggleDonationModal(true),
}))(DonateSectionBase)

export const ChampionSection = ({ }) => (
  <TwoColumnSection
    col1={
      <ColumnBlock
        styles={{
          bg: "purple",
          color: "pink",
        }}
      >
        <CTAHeadingBlock heading="CHAMPIONS FOR LGBTQIA+ YOUTH" />
      </ColumnBlock>
    }
    col2={
      <ColumnBlock
        styles={{
          bg: "neonBlue",
        }}
      >
        <CTAHeadingBlock
          heading="CHANGING THE LIVES OF LGBTQIA+ YOUTH IN AUSTRALIA"
          body="We’re leading change, building social inclusion, and advocating for an Australia where all young people are safe, empowered, and surrounded by people that support them."
          buttonLabel="Read about our impact"
          onButtonClick={() => navigate("/about")}
          smallHeading
          widthLimit
        />
      </ColumnBlock>
    }
  />
)

export const WhatWeDoSection = ({ }) => (
  <Container>
    <Section>
      <CalloutTextBlocks
        heading="What we do"
        blocks={[
          {
            heading: "Life-affirming social inclusion",
            body:
              "Through a preventative model of mental health support, we tackle social isolation by creating spaces where young people belong.",
          },
          {
            heading: "Education & advocacy",
            body:
              "We transform communities through LGBTQIA+ training, resources, and digital campaigns that enable others to champion inclusivity.",
          },
          {
            heading: "Youth empowerment",
            body:
              "We believe in equipping young people with the skills they need to be at the forefront of driving change.",
          },
        ]}
      />
    </Section>
  </Container>
)

export const ImgSection = ({ }) => (
  <img
    src={footerImage}
    alt="Happy youth"
    sx={{
      width: "100%",
      display: "block",
    }}
  />
)

const ImpactFooter = ({ hideDonate, hideWhatWeDo, reverse, noPt, noPb }) => (
  <div sx={{ display: 'flex', flexDirection: reverse ? 'column-reverse' : 'column' }}>
    {!noPt && <Spacer.Large />}
    <ChampionSection />
    {!hideWhatWeDo && <WhatWeDoSection />}
    {!hideWhatWeDo && <ImgSection />}
    {!hideDonate && <DonateSection />}
    {!noPb && <Spacer.Large />}
  </div>
)

export default ImpactFooter
